import {
  AttendanceEnumsOvertimePoolUpdateFrequencyEnum,
  AttendanceEnumsPoolTypeEnum,
  AttendanceOvertimePool,
} from 'generated/resources/graphql'

type OvertimePoolType = Exclude<
  AttendanceOvertimePool,
  'attendanceEmployeesSettingId' | 'negativeTransfers'
>

class OvertimePool {
  id: number
  capacity: string
  poolType: AttendanceEnumsPoolTypeEnum
  unlimitedCapacity: boolean
  updateFrequency: AttendanceEnumsOvertimePoolUpdateFrequencyEnum

  constructor(overtimePool: OvertimePoolType) {
    this.id = overtimePool.id
    this.capacity = overtimePool.capacity
    this.poolType = overtimePool.poolType
    this.unlimitedCapacity = overtimePool.unlimitedCapacity
    this.updateFrequency = overtimePool.updateFrequency
  }
}

export class OvertimePoolsCollection {
  pools: OvertimePool[]

  constructor(pools: OvertimePoolType[]) {
    this.pools = pools.map((pool) => new OvertimePool(pool))
  }

  findBalancePool(): OvertimePool | undefined {
    return this.pools.find((pool) => pool.poolType === 'balance')
  }

  findTimeOffPool(): OvertimePool | undefined {
    return this.pools.find((pool) => pool.poolType === 'timeoff')
  }

  getBalancePoolCapacity(): number {
    return +(this.findBalancePool()?.capacity || Infinity)
  }

  getTimeOffPoolCapacity(): number {
    return +(this.findTimeOffPool()?.capacity || 0)
  }

  compensationPeriod(): string | undefined {
    return this.pools.find((pool) => pool.updateFrequency)?.updateFrequency
  }
}
